import React from 'react'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
  className?: string
}

const sizeMap = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-20 h-20',
  xl: 'w-24 h-24',
}

export default function Logo({ size = 'md', showText = false, className = '' }: LogoProps) {
  const dim = sizeMap[size]

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/hero.png"
        alt="ProperWallet"
        className={`${dim} object-contain drop-shadow-[0_4px_12px_rgba(67,160,71,0.35)]`}
        draggable={false}
      />
      {showText && (
        <span className="font-extrabold text-white tracking-[-0.02em]" style={{ fontSize: size === 'sm' ? 18 : size === 'md' ? 22 : 28 }}>
          ProperWallet
        </span>
      )}
    </div>
  )
}
